module.exports = __webpack_public_path__ + "img/digi.0fecb6b8.png";